module.exports = __webpack_public_path__ + "media/images/bubble-img-03-785d9955f4d5ba22a4591b842c8b2d55.svg";